import type { Components, Theme } from "@mui/material";

export const toggleButtonTheme: Components<Theme>["MuiToggleButton"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      border: "none",
      backgroundColor: theme.palette.secondary.main,
      "&.Mui-selected": {
        backgroundColor: "white",
        "&:hover": {
          backgroundColor: theme.palette.custom.surfaceTertiary,
        },
      },
      "&.Mui-disabled": {
        border: "none",
      },
    }),
  },
};
